import api from './axiosInstance';

export async function getActiveClientsWithMonitoring(params, signal) {
  try {
    const { page, pageSize, sortBy, desc, search, active } = params;

    const queryObject = {
      page,
      pageSize,
    };

    if (sortBy) queryObject.sortBy = sortBy;
    if (desc !== undefined) queryObject.desc = desc;
    if (search) queryObject.search = search;
    if (active !== undefined && active !== null) queryObject.active = active;

    const response = await api.get('/clients/active-with-monitoring', {
      params: queryObject,
      signal,
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching clients with monitoring:', error);
    throw error;
  }
}
